import { modifyText } from "./commonFunction";
import { messages } from "./messages";

export const loginFormValidations = (
  fieldValues,
  temp,
  values,
  setValues,
  setErrors
) => {
  if ("username" in fieldValues) {
    temp.username = fieldValues.username ? "" : messages.errors.user_req;
  }
  if ("password" in fieldValues) {
    temp.password = fieldValues.password ? "" : messages.errors.pass_req;
  }

  setErrors({
    ...temp,
  });
  if (fieldValues === values) return Object.values(temp).every((x) => x === "");
};

export const takeDetailsValidation = (
  fieldValues,
  temp,
  values,
  setValues,
  setErrors
) => {
  if ("restaurant" in fieldValues) {
    temp.restaurant = fieldValues.restaurant ? "" : "Please enter restaurant!";
  }
  if ("branch" in fieldValues) {
    temp.branch = fieldValues.branch ? "" : "Please enter branch!";
  }
  setErrors({
    ...temp,
  });
  if (fieldValues === values) return Object.values(temp).every((x) => x === "");
};
